import angular from 'angular';
import uiRouter from 'angular-ui-router';
import expenseImportComponent from './expense-import.component';

let expenseImportModule = angular.module('expenseImport', [
  uiRouter,
])

.config(($stateProvider) => {
  "ngInject";

  $stateProvider.state('expense-import', {
    parent: 'app',
    url: '/admin/expense-reports/import',
    data: {
      pageHeader: true,
      pageTitle: 'Import Expense Report',
      pageDesc: 'Create an expense report on behalf of an employee',
      breadcrumbLink: 'admin.expenses',
      breadcrumbText: 'Review Expense Reports'
    },
    template: '<expense-import></expense-import>'
  });
})

.component('expenseImport', expenseImportComponent);

export default expenseImportModule;



// WEBPACK FOOTER //
// ./client/pages/admin/expense-import/expense-import.js